export default {"src":"/_next/static/media/database-white.8e606545.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};